import { PropTypes } from "prop-types"
import classNames from "classnames"

import Button from "../Button"

export function PaginationPage(props) {
  const { ariaLabel, label, type, onChange, value = 1, active = false, disabled = false } = props

  const handleClick = e => {
    onChange(Number(e.currentTarget.value))
  }

  return (
    <li className={classNames("oj-pagination-page", { active })}>
      <Button
        type="button"
        aria-label={ariaLabel}
        aria-current={active ? "page" : false}
        disabled={disabled}
        value={value}
        onClick={handleClick}
      >
        <span className={type}>{label}</span>
      </Button>
    </li>
  )
}

PaginationPage.propTypes = {
  active: PropTypes.bool,
  ariaLabel: PropTypes.string,
  type: PropTypes.string,
  disabled: PropTypes.bool,
  label: PropTypes.node,
  value: PropTypes.number,
  onChange: PropTypes.func.isRequired
}

export default PaginationPage
